export default __webpack_public_path__ + "static/media/lock_alert.2b30ff0d.mp3";